import { SxProps } from '@mui/material';

export const newsletterGridTitleSubtitleStylesSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	padding: '10px 15px 0 15px',
};
